import styled from "styled-components"

import { color } from "../../../atoms/colors"
// eslint-disable-next-line import/no-unresolved
import nexticon from "../../../images/icons/slidenexticon.svg"

export const StandardSlideWrap = styled.div`
  &.bottom-padding {
    padding-bottom: 96px;
    @media (max-width: 991.98px) {
      padding-bottom: 56px;
    }
    @media (max-width: 767.98px) {
      padding-bottom: 40px;
    }
  }
  &.top-padding {
    padding-top: 96px;
    @media (max-width: 991.98px) {
      padding-top: 56px;
    }
    @media (max-width: 767.98px) {
      padding-top: 40px;
    }
  }
  position: relative;
  &.bg-sprite {
    .eyebrow {
      border: 2px solid ${color.oxfordBlue[600]} !important;
      color: ${color.oxfordBlue[600]} !important;
    }
  }
  &.bg-plum {
    .heading {
      color: ${color.common.white} !important;
    }
  }
  &.floatabove {
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      background-color: ${color.common.white};
      width: 100%;
      min-height: 60%;
    }
    .heading {
      color: ${color.oxfordBlue[900]} !important;
    }
  }
  .container {
    max-width: 1170px !important;
    @media (max-width: 991.98px) {
      max-width: 770px !important;
    }
    @media (max-width: 767.98px) {
      max-width: 506px !important;
    }
  }
  .heading-container {
    text-align: center;
    max-width: 770px !important;
    margin: 0 auto;
    .eyebrow {
      font-size: 14px;
      font-weight: 500;
      border: 2px solid ${color.secondary[600]};
      border-radius: 40px;
      padding: 7px 15px 3px;
      display: inline;
      line-height: 1em;
      display: inline-block;
      margin-bottom: 24px;
      color: ${color.secondary[600]};
      @media (max-width: 575.98px) {
        font-size: 12px;
        line-height: 18px;
      }
    }
    .heading {
      text-align: center;
      letter-spacing: -0.02em;
      font-style: normal;
      font-weight: 900;
      color: ${color.oxfordBlue[900]};
      left: calc(50% - 770px / 2);
      top: 0%;
      bottom: 63.86%;
    }
    h1.heading {
      font-size: 48px;
      line-height: 60px;
      @media (max-width: 991.98px) {
        font-size: 36px;
        line-height: 44px;
      }
      @media (max-width: 575.98px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
    h2.heading {
      font-size: 36px;
      line-height: 44px;
      @media (max-width: 575.98px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
    .description {
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      font-weight: 400;
      max-width: 770px;
      flex: none;
      align-self: stretch;
      flex-grow: 0;
      top: 45.78%;
      bottom: 0%;
      margin: 0 auto;
      * {
        color: ${color.copy[700]};
      }
    }
  }
  .main-container {
    .tabs-area {
      display: flex;
      flex-direction: row;
      justify-content: center;
      box-shadow: inset 0px 0px 0 ${color.copy[200]},
        inset -0px -2px 0 ${color.copy[200]};
      background: ${color.common.white};
      margin-bottom: 25px;
      flex-wrap: wrap;
      button {
        flex-wrap: wrap;
        padding: 18px 12px 10px;
        text-transform: none;
        color: ${color.copy[400]};
        font-size: 1.1em;
        font-family: Avenir, sans-serif;
        font-style: normal;
        font-weight: 800;
        line-height: 30px;
        min-width: fit-content;
        border-top: none;
        border-right: none;
        border-left: none;
        border-bottom: 2px solid ${color.common.transparent};
        background: ${color.common.transparent};
      }
      .active-button {
        color: ${color.primary[900]};
        border-bottom: 2px solid ${color.primary[900]};
      }
    }
    .inactive {
      display: none;
    }
    .active-slide {
      display: block;
      background: linear-gradient(
          112.6deg,
          rgba(137, 186, 239, 0.1) 3.62%,
          rgba(124, 170, 233, 0.1) 84.69%
        ),
        linear-gradient(
          250.72deg,
          rgba(83, 177, 253, 0.4) -8.68%,
          rgba(224, 242, 254, 0.4) 51.75%,
          rgba(237, 251, 255, 0.4) 117.43%
        ),
        linear-gradient(0deg, ${color.common.white}, ${color.common.white});
      border: 10px;
      border-radius: 24px;
    }
    .slide-desc {
      h1,
      h2,
      h3,
      h5,
      h6 {
        color: ${color.oxfordBlue[900]};
        position: static;
        left: 0px;
        top: 88px;
        letter-spacing: -0.02em;
        font-weight: 800;
        font-size: 24px;
        line-height: 32px;
        padding-bottom: 15px;
      }
      h4 {
        color: ${color.oxfordBlue[400]};
        font-weight: 900;
        font-size: 18px;
        line-height: 24px;
        text-transform: uppercase;
        padding-bottom: 24px;
      }
      p {
        max-width: 479px;
        color: ${color.copy[700]};
        font-weight: 400;
        font-size: 18px;
        line-height: 29px;
        left: 0%;
        right: 0%;
        top: 40%;
        padding-bottom: 10px;
        @media (max-width: 991.98px) {
          max-width: 100%;
        }
      }
      padding: 94px;
      @media (max-width: 991.98px) {
        padding: 24px;
        padding-bottom: 48px !important;
      }
      a {
        color: ${color.primary[350]} !important;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          background-image: url(${nexticon});
          background-repeat: no-repeat;
          background-position: right center;
          display: inline-block;
          width: 5px;
          height: 8px;
          padding-left: 15px;
        }
      }
      .accordion {
        button {
          width: 100%;
          position: relative;
          background-color: ${color.common.transparent};
          padding: 0.75rem 0rem 0rem 0rem;
          border: 1px solid rgba(0, 0, 0, 0.125);
          border-left: 0;
          border-right: 0;
          border-bottom: 0;
          font-size: 24px;
          font-weight: 800;
          line-height: 35px;
          color: ${color.oxfordBlue[900]};
          letter-spacing: -0.02em;
          text-align: left;
          .arrowIcon {
            position: absolute;
            right: 0px;
            transition: all 450ms ease-in-out;
            &.expanded {
              transform: rotate(180deg);
            }
          }
        }
        .hide-me {
          display: none;
          height: 0;
          transition: height 0.35s ease-out;
        }
      }
    }
    .MuiTabs-indicator {
      height: 2px;
      background-color: ${color.primary[900]} !important;
    }
    .Mui-selected {
      color: ${color.primary[900]} !important;
    }
    .MuiButtonBase-root {
      padding-top: 18px;
      padding-bottom: 10px;
      text-transform: none;
      color: ${color.copy[400]};
      font-size: 1.1em;
      font-family: "Avenir", sans-serif;
      font-style: normal;
      font-weight: 800;
      line-height: 30px;
      max-width: 280px;
      min-width: 25%;
      @media only screen and (min-width: 767.98px) and (max-width: 959px) {
        max-width: 40%;
        min-width: 35%;
        font-size: 1.1em;
        .svg-container {
          max-width: 75%;
        }
      }
      @media only screen and (min-width: 480px) and (max-width: 767px) {
        max-width: 35%;
        min-width: 25%;
        font-size: 0.875em;
      }
      @media only screen and (min-width: 320px) and (max-width: 479px) {
        max-width: 35%;
        min-width: 25%;
        font-size: 0.875em;
      }
      @media (max-width: 767.98px) {
        img {
          display: none;
        }
      }
    }
    .slideImg {
      object-fit: contain;
      max-width: 470px;
      max-height: 650px;
      height: 100%;
      width: 100%;
      @media (max-width: 991.98px) {
        padding-top: 40px;
      }
    }
    .slide-video {
      position: relative;
      text-align: center;
      img {
        max-width: 100%;
      }
      .playicon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        span {
          display: inline-block;
          background-color: ${color.primary[350]};
          cursor: pointer;
          border-radius: 50%;
          animation: pulse 2.5s infinite;
          width: 72px;
          height: 72px;
          line-height: 72px;
          padding-left: 6px;
          img {
            width: 26px;
            height: 30px;
          }
        }
      }
    }
  }
`
